"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function destroyRequestHandlerConfig(config) {
  if (config.requestHandler.destroy) config.requestHandler.destroy();
}

exports.destroyRequestHandlerConfig = destroyRequestHandlerConfig;